import React, { useEffect, useState } from "react";
import apiClient from "../api.js";
import { Link, useNavigate, useParams } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import { FaLocationDot, FaIndianRupeeSign } from "react-icons/fa6";
import { FaBuilding } from "react-icons/fa";
import Popup from "../components/Popup.jsx";
import Animationthankyou from "../assets/img/Animationthankyou.gif";
import Canonical from "../components/Canonical.js";
import LocationPagesSeo from "../components/LocationPagesSeo.jsx";
import LocationPagesSeoBottom from "../components/LocationPagesSeoBottom.jsx";

const Propertiesbyregion = () => {
  const params = useParams();
  const [property, setProperty] = useState([]);
  const [propertySingle, setPropertySingle] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [subject, setSubject] = useState("");
  const [possessionDropdown, setPossessionDropdown] = useState(false);
  const [selectedPossession, setSelectedPossession] = useState("");
  // const [bedroomDropdown, setBedroomDropdown] = useState(false);
  // const [selectedBedroom, setSelectedBedroom] = useState("");
  // const [priceDropdown, setPriceDropdown] = useState(false);
  // const [selectedPrice, setSelectedPrice] = useState("");
  const urlVariableChange = params.subregionname.replace(/-/g, " ");

  // Bedroom options
  // const bedroomOptions = ["Studios", "1BHK", "2BHK", "3BHK", "4BHK"];

  // Price range options
  // const priceOptions = [
  //   "10L to 50 L",
  //   "51L to 1 cr",
  //   "1 cr to 1.5 cr",
  //   "2 cr to 2.5 cr",
  //   "3 cr to 4 cr",
  // ];

  // Generate possession months (current month and next 24 months)
  const generatePossessionMonths = () => {
    const months = ["Ready to Move"];
    const currentDate = new Date();
    for (let i = 0; i < 36; i++) {
      const date = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + i,
        1,
      );
      const monthYear = date.toLocaleDateString("en-US", {
        month: "long",
        year: "numeric",
      });
      months.push(monthYear);
    }
    return months;
  };

  const possessionMonths = generatePossessionMonths();

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        setLoading(true);
        setError("");

        // Build query parameters based on filters
        let queryParams = new URLSearchParams();
        if (selectedPossession) {
          queryParams.append("possessiondate", selectedPossession);
        }
        // if (selectedBedroom) {
        //   queryParams.append("bhk", selectedBedroom);
        // }
        // if (selectedPrice) {
        //   queryParams.append("pricerange", selectedPrice);
        // }

        const queryString = queryParams.toString();
        const apiUrl = queryString
          ? `listing/propertysubregion/${urlVariableChange}?${queryString}`
          : `listing/propertysubregion/${urlVariableChange}`;

        const res = await apiClient.get(apiUrl);
        if (res.status === 200) {
          setPropertySingle(res.data[0]);
          setProperty(res.data);
          setSubject(res.data[0].subregion);
          setError("");
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        setProperty([]);
        if (error.response?.status === 404) {
          setError("No properties found matching your filters.");
        } else {
          setError(
            error.response?.data?.message || "Error fetching properties",
          );
        }
      }
    };

    fetchProperties();
  }, [urlVariableChange, selectedPossession]);

  const onShowMoreClick = async () => {
    const numberOfProperty = property.length; // Already loaded properties
    const limit = 10;

    try {
      setLoading(true);
      const res = await apiClient.get(
        `listing/propertysubregion/${params.subregionname}?skip=${numberOfProperty}&limit=${limit}`,
      );

      if (res.data.length <= 10) {
        // console.log(res.data);

        // setShowMore(false);
        setLoading(false);
        // setError(false);

        setProperty([...property, ...res.data]);
      }
      // setShowMore(true);
    } catch (error) {
      //   setError(true);
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   let isFetching = false;

  //   const handleScroll = () => {
  //     const scrollTop =
  //       document.documentElement.scrollTop || document.body.scrollTop;
  //     const windowHeight = window.innerHeight;
  //     const docHeight = document.documentElement.scrollHeight;

  //     const scrolledPercent = (scrollTop + windowHeight) / docHeight;

  //     // Only trigger if not already loading and past 50%
  //     if (scrolledPercent >= 0.5 && !isFetching && !loading) {
  //       isFetching = true;
  //       onShowMoreClick().finally(() => {
  //         isFetching = false;
  //       });
  //     }
  //   };

  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, [loading, property]);

  // handle popup button
  const [popupData, setPopupData] = useState("");

  const handleButtonClick = (dataName) => {
    // Set the value you want to send to the Popup
    // console.log(dataName);
    setPopupData(dataName);
  };

  // save lead form data

  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const res = await apiClient.post("emailsend/send-email", {
        email,
        subject,
        mobile,
        name,
      });

      if (res) {
        // Hide the main form popup
        const mainPopup = document.getElementById("staticBackdrop");
        if (mainPopup) {
          const bootstrapModal = window.bootstrap.Modal.getInstance(mainPopup);
          if (bootstrapModal) bootstrapModal.hide();
        }
        navigate("/thank-you"); // Redirect after successful response
        // window.location.reload(); // Forces a full page reload
        setShowSuccessPopup(true); // Show success popup
        setEmail("");
        setName("");
        setMobile("");
        setSubject("");
      }
    } catch (error) {
      // console.log(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleSuccessPopupClose = () => {
    setShowSuccessPopup(false);
    navigate("/thank-you"); // Redirect or perform other actions if necessary
    window.location.reload(); // Forces a full page reload
  };

  const getDisplaySubregion = (subregion) => {
    if (subregion === "Dombivali") return "Dombivli";
    else if (subregion === "Vikroli") return "Vikhroli";
    else if (subregion === "Vadala") return "Wadala";
    else return subregion;
  };

  const canonicalUrl = `https://homesdekho.com/propertiesbyregion/${params.subregionname}`;
  const metaTitle = `Flats for Sale in ${propertySingle.subregion}, Mumbai | HomesDekho`;
  // const metaTitle = `Properties for Sale in ${propertySingle.subregion}, Mumbai | Homes Dekho`;
  const hrfLangTag = `https://homesdekho.com/propertiesbyregion/${params.subregionname}`;
  const description = `Discover 1, 2, 3 BHK residential properties in ${propertySingle.subregion}, Mumbai by top builders. Get brochures, floor plans & expert help with Homes Dekho. Book your flat now.`;

  return (
    <>
      <Canonical
        canonicalUrl={canonicalUrl}
        title={metaTitle}
        description={description}
        hrfLang={hrfLangTag}
      />
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12">
            {loading && (
              <div className="spinner-border text-danger" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* property Detail  */}
      <main className="main-section">
        <section className="main-side">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="region-name-div">
                  <ul className="region-name-ul">
                    <li className="region-name-li">
                      <Link>Homes In Mumbai</Link>
                      <IoIosArrowDown />
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-12">
                <div className="region-name-div">
                  <ul className="property-region-name-ul">
                    <li className="property-region-name-li">
                      <Link>Homes In Mumbai</Link>
                    </li>
                    <li className="property-region-name-li">
                      <Link>
                        {getDisplaySubregion(propertySingle.subregion)}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-12">
                <div className="filter-main-div">
                  <ul className="filter-main-ul">
                    <li
                      className="filter-main-li"
                      onClick={() => setPossessionDropdown(!possessionDropdown)}
                      style={{ position: "relative", cursor: "pointer" }}
                    >
                      {selectedPossession || "Possession"}
                      <IoIosArrowDown
                        style={{
                          transform: possessionDropdown
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                          transition: "transform 0.3s ease",
                        }}
                      />
                      {possessionDropdown && (
                        <div
                          style={{
                            position: "absolute",
                            top: "100%",
                            left: 0,
                            backgroundColor: "white",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            minWidth: "150px",
                            maxHeight: "300px",
                            overflowY: "auto",
                            zIndex: 10,
                            boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                          }}
                        >
                          {possessionMonths.map((month, index) => (
                            <div
                              key={index}
                              onClick={(e) => {
                                e.stopPropagation();
                                setSelectedPossession(month);
                                setPossessionDropdown(false);
                              }}
                              style={{
                                padding: "10px 15px",
                                cursor: "pointer",
                                borderBottom: "1px solid #f0f0f0",
                                hover: { backgroundColor: "#f9f9f9" },
                              }}
                              onMouseEnter={(e) =>
                                (e.target.style.backgroundColor = "#f9f9f9")
                              }
                              onMouseLeave={(e) =>
                                (e.target.style.backgroundColor = "white")
                              }
                            >
                              {month}
                            </div>
                          ))}
                        </div>
                      )}
                    </li>
                    {/* <li
                      className="filter-main-li"
                      onClick={() => setBedroomDropdown(!bedroomDropdown)}
                      style={{ position: "relative", cursor: "pointer" }}
                    >
                      {selectedBedroom || "Bedrooms"}
                      <IoIosArrowDown
                        style={{
                          transform: bedroomDropdown
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                          transition: "transform 0.3s",
                        }}
                      />
                      {bedroomDropdown && (
                        <div
                          style={{
                            position: "absolute",
                            top: "100%",
                            left: 0,
                            backgroundColor: "white",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            minWidth: "150px",
                            zIndex: 1000,
                            marginTop: "5px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          {bedroomOptions.map((bedroom, index) => (
                            <div
                              key={index}
                              onClick={(e) => {
                                e.stopPropagation();
                                setSelectedBedroom(bedroom);
                                setBedroomDropdown(false);
                              }}
                              style={{
                                padding: "10px 15px",
                                cursor: "pointer",
                                borderBottom: "1px solid #f0f0f0",
                              }}
                              onMouseEnter={(e) =>
                                (e.target.style.backgroundColor = "#f9f9f9")
                              }
                              onMouseLeave={(e) =>
                                (e.target.style.backgroundColor = "white")
                              }
                            >
                              {bedroom}
                            </div>
                          ))}
                        </div>
                      )}
                    </li>
                    <li
                      className="filter-main-li"
                      onClick={() => setPriceDropdown(!priceDropdown)}
                      style={{ position: "relative", cursor: "pointer" }}
                    >
                      {selectedPrice || "Price"}
                      <IoIosArrowDown
                        style={{
                          transform: priceDropdown
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                          transition: "transform 0.3s",
                        }}
                      />
                      {priceDropdown && (
                        <div
                          style={{
                            position: "absolute",
                            top: "100%",
                            left: 0,
                            backgroundColor: "white",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            minWidth: "150px",
                            zIndex: 1000,
                            marginTop: "5px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          {priceOptions.map((price, index) => (
                            <div
                              key={index}
                              onClick={(e) => {
                                e.stopPropagation();
                                setSelectedPrice(price);
                                setPriceDropdown(false);
                              }}
                              style={{
                                padding: "10px 15px",
                                cursor: "pointer",
                                borderBottom: "1px solid #f0f0f0",
                              }}
                              onMouseEnter={(e) =>
                                (e.target.style.backgroundColor = "#f9f9f9")
                              }
                              onMouseLeave={(e) =>
                                (e.target.style.backgroundColor = "white")
                              }
                            >
                              {price}
                            </div>
                          ))}
                        </div>
                      )}
                    </li> */}
                  </ul>
                </div>
              </div>
              <div className="col-md-12">
                <LocationPagesSeo location={urlVariableChange} />
              </div>
              <div className="col-md-12">
                <div className="property-region-name-li-region">
                  <h1 className="property-name-region">
                    Properties for Sale in {propertySingle.subregion}, Mumbai
                  </h1>
                </div>
              </div>

              <div className="col-md-12">
                {error ? (
                  <div className="col-md-12 text-center">
                    <p
                      style={{
                        fontSize: "18px",
                        marginTop: "20px",
                        color: "#d32f2f",
                        fontWeight: "bold",
                      }}
                    >
                      {error}
                    </p>
                  </div>
                ) : Array.isArray(property) && property.length > 0 ? (
                  property.map((propertyDetail, index) => (
                    <div
                      key={propertyDetail._id}
                      className="devloper-name-property-div"
                    >
                      <div className="devloper-name-property-inner-div">
                        <div className="devloper-name-property-img-div">
                          <Link to={`/property-detail/${propertyDetail.slug}`}>
                            <img
                              className="devloper-name-property-img "
                              src={propertyDetail.imageUrls}
                              alt={propertyDetail.name}
                            />
                          </Link>
                        </div>
                        <div className="property-detail-right-div">
                          <Link
                            to={`/property-detail/${propertyDetail.slug}`}
                            className="property-devloper-name-txt"
                          >
                            {propertyDetail.name}
                          </Link>
                          <div className="property-devloper-name-detail-div">
                            <FaLocationDot />
                            <p className="property-by-subregion-address-txt">
                              {propertyDetail.address}
                            </p>
                          </div>
                          <div className="property-devloper-name-detail-div">
                            <FaBuilding />
                            <p className="property-by-subregion-address-txt">
                              {propertyDetail.BHK &&
                              Array.isArray(propertyDetail.BHK) ? (
                                propertyDetail.BHK.map((bhk, idx) => (
                                  <span key={idx}>
                                    {bhk}
                                    {idx < propertyDetail.BHK.length - 1 &&
                                      ", "}
                                  </span>
                                ))
                              ) : (
                                <span>Loading data...</span>
                              )}{" "}
                              BHK
                            </p>
                          </div>
                          <div className="best-deal-price-range-div">
                            <FaIndianRupeeSign />
                            <p className="property-by-subregion-address-txt">
                              {propertyDetail.price}
                            </p>
                          </div>
                          <div className="property-devloper-btn-div">
                            <Link
                              to={`/property-detail/${propertyDetail.slug}`}
                              className="view-detail-btn-property"
                            >
                              View Details
                            </Link>
                            <button
                              data-bs-toggle="modal"
                              data-bs-target="#staticBackdrop"
                              onClick={() =>
                                handleButtonClick(propertySingle.name)
                              }
                              className="get-call-btn-property-by-region"
                            >
                              Enquire Now
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : !error ? (
                  <div className="col-md-12 text-center">
                    <p style={{ fontSize: "18px", marginTop: "20px" }}>
                      No properties found.
                    </p>
                  </div>
                ) : null}
                {/* {showMore === false ? (
                  ""
                ) : (
                  <button className="btn btn-success" onClick={onShowMoreClick}>
                    Show More
                  </button>
                )} */}

                <div className="col-md-12">
                  {!selectedPossession &&
                    property.length % 10 === 0 &&
                    property.length > 0 && (
                      <div className="text-center my-4">
                        <button
                          className="get-call-btn-property-by-region"
                          onClick={onShowMoreClick}
                          disabled={loading}
                        >
                          {loading ? "Loading..." : "View More Properties"}
                        </button>
                      </div>
                    )}
                </div>
              </div>

              <LocationPagesSeoBottom location={urlVariableChange} />

              <div className="col-md-12">
                <div className="devloper-name-property-div">
                  <div className="">
                    <h2 className="configuration-txt">FAQs</h2>
                  </div>
                  <div
                    class="accordion custome-accordian"
                    id="accordionExample"
                  >
                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button
                          class="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                        >
                          Why is {getDisplaySubregion(propertySingle.subregion)}{" "}
                          becoming a popular residential area?
                        </button>
                      </h2>
                      <div
                        id="collapseOne"
                        class="accordion-collapse collapse show"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          {getDisplaySubregion(propertySingle.subregion)} offers
                          a balance of affordable housing, improving
                          connectivity, and modern amenities - making it an
                          ideal choice for both homebuyers and investors.
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          What types of properties are available in{" "}
                          {getDisplaySubregion(propertySingle.subregion)}?
                        </button>
                      </h2>
                      <div
                        id="collapseTwo"
                        class="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          You can find 1BHK flats in{" "}
                          {getDisplaySubregion(propertySingle.subregion)} under
                          30 lacs, 2BHK apartments, and several new property
                          projects in{" "}
                          {getDisplaySubregion(propertySingle.subregion)} with
                          modern features and layouts.
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseThree"
                          aria-expanded="false"
                          aria-controls="collapseThree"
                        >
                          Are there affordable flats in{" "}
                          {getDisplaySubregion(propertySingle.subregion)} for
                          first-time buyers?
                        </button>
                      </h2>
                      <div
                        id="collapseThree"
                        class="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          Yes, many developers offer affordable options like
                          1BHK in{" "}
                          {getDisplaySubregion(propertySingle.subregion)} under
                          35 lacs and budget flats with flexible payment
                          schemes.
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFour"
                          aria-expanded="false"
                          aria-controls="collapseFour"
                        >
                          Is {getDisplaySubregion(propertySingle.subregion)}{" "}
                          suitable for families?
                        </button>
                      </h2>
                      <div
                        id="collapseFour"
                        class="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          Absolutely. With reputed schools, hospitals, and local
                          markets nearby,{" "}
                          {getDisplaySubregion(propertySingle.subregion)}{" "}
                          provides a secure and convenient lifestyle for
                          families.
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFive"
                          aria-expanded="false"
                          aria-controls="collapseFive"
                        >
                          What kind of growth can investors expect in{" "}
                          {getDisplaySubregion(propertySingle.subregion)}?
                        </button>
                      </h2>
                      <div
                        id="collapseFive"
                        class="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          {getDisplaySubregion(propertySingle.subregion)} has
                          shown steady appreciation over the past few years,
                          with expected growth of around{" "}
                          {getDisplaySubregion(propertySingle.subregion)}%
                          annually driven by infrastructure development.
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseSix"
                          aria-expanded="false"
                          aria-controls="collapseSix"
                        >
                          Are there new launches or upcoming projects in{" "}
                          {getDisplaySubregion(propertySingle.subregion)}?
                        </button>
                      </h2>
                      <div
                        id="collapseSix"
                        class="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          Yes, several new property launches in{" "}
                          {getDisplaySubregion(propertySingle.subregion)} are
                          underway, offering modern homes, eco-friendly designs,
                          and community-driven living spaces.
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseSeven"
                          aria-expanded="false"
                          aria-controls="collapseSeven"
                        >
                          How good is the connectivity in{" "}
                          {getDisplaySubregion(propertySingle.subregion)}?
                        </button>
                      </h2>
                      <div
                        id="collapseSeven"
                        class="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          Connectivity in{" "}
                          {getDisplaySubregion(propertySingle.subregion)} is
                          excellent, with multiple transport options and ongoing
                          infrastructure improvements enhancing accessibility to
                          nearby business and residential hubs.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 mobile-property">
                <div className="property-details-div">
                  <p className="best-deal-txt">
                    Best Deal in {getDisplaySubregion(propertySingle.subregion)}
                  </p>
                  <div className="best-property-deal-div">
                    <Link to={`/property-detail/${propertySingle.slug}`}>
                      <img
                        src={propertySingle.imageUrls}
                        className="best-deal-property-img img-fluid"
                        alt=""
                      />
                    </Link>
                    <Link
                      to={`/property-detail/${propertySingle.slug}`}
                      className="best-deal-property-name"
                    >
                      {propertySingle.name}
                    </Link>
                    <div className="best-deal-property-address-div">
                      <FaLocationDot className="location-icon" />
                      <p className="best-deal-property-address-txt">
                        {propertySingle.address}
                      </p>
                    </div>
                    <div className="best-ceal-property-detail-price">
                      <div className="best-deal-bhk-range">
                        <FaBuilding />
                        <p className="best-deal-property-address-txt">
                          {propertySingle.BHK &&
                          Array.isArray(propertySingle.BHK) ? (
                            propertySingle.BHK.map((bhk, index) => (
                              <span key={index}>
                                {bhk}
                                {index < propertySingle.BHK.length - 1 && ", "}
                              </span>
                            ))
                          ) : (
                            <span>Loading data...</span>
                          )}{" "}
                          BHK
                        </p>
                      </div>
                      <div className="best-deal-price-range-div">
                        <FaIndianRupeeSign />
                        <p className="best-deal-property-address-txt">
                          {propertySingle.price}
                        </p>
                      </div>
                    </div>
                    <div className="best-deal-btn-div">
                      <Link
                        to={`/property-detail/${propertySingle.slug}`}
                        className="view-detail-btn"
                      >
                        View Details
                      </Link>

                      <button
                        data-bs-toggle="modal"
                        data-bs-target="#staticBackdrop"
                        onClick={() => handleButtonClick(propertySingle.name)}
                        className="get-call-btn"
                      >
                        Enquire Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="side-bar">
          <div className="container">
            <div className="row">
              {/* property detail  */}
              <div className="col-md-12">
                <div className="property-details-div">
                  <p className="best-deal-txt">
                    Best Deal in {getDisplaySubregion(propertySingle.subregion)}
                  </p>
                  <div className="best-property-deal-div">
                    <Link to={`/property-detail/${propertySingle.slug}`}>
                      <img
                        src={propertySingle.imageUrls}
                        className="best-deal-property-img img-fluid"
                        alt=""
                      />
                    </Link>
                    <Link
                      to={`/property-detail/${propertySingle.slug}`}
                      className="best-deal-property-name"
                    >
                      {propertySingle.name}
                    </Link>
                    <div className="best-deal-property-address-div">
                      <FaLocationDot className="location-icon" />
                      <p className="best-deal-property-address-txt">
                        {propertySingle.address}
                      </p>
                    </div>
                    <div className="best-ceal-property-detail-price">
                      <div className="best-deal-bhk-range">
                        <FaBuilding />
                        <p className="best-deal-property-address-txt">
                          {propertySingle.BHK &&
                          Array.isArray(propertySingle.BHK) ? (
                            propertySingle.BHK.map((bhk, index) => (
                              <span key={index}>
                                {bhk}
                                {index < propertySingle.BHK.length - 1 && ", "}
                              </span>
                            ))
                          ) : (
                            <span>Loading data...</span>
                          )}{" "}
                          BHK
                        </p>
                      </div>
                      <div className="best-deal-price-range-div">
                        <FaIndianRupeeSign />
                        <p className="best-deal-property-address-txt">
                          {propertySingle.price}
                        </p>
                      </div>
                    </div>
                    <div className="best-deal-btn-div">
                      <Link
                        to={`/property-detail/${propertySingle.slug}`}
                        className="view-detail-btn"
                      >
                        View Details
                      </Link>

                      <button
                        data-bs-toggle="modal"
                        data-bs-target="#staticBackdrop"
                        onClick={() => handleButtonClick(propertySingle.name)}
                        className="get-call-btn"
                      >
                        Enquire Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* property detail  */}
              <div className="col-md-12">
                <div className="main-form-div">
                  <div className="need-help-txt-div">
                    <h4 className="need-help-txt">Need Help?</h4>
                  </div>
                  <div className="lead-form-div">
                    <form onSubmit={handleSubmit} className="lead-form">
                      <input
                        placeholder="Name*"
                        className="lead-form-input"
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                      />

                      <input
                        placeholder="Mobile*"
                        className="lead-form-input"
                        type="tel"
                        pattern="[789][0-9]{9}"
                        value={mobile}
                        onChange={(e) => setMobile(e.target.value)}
                        required
                      />
                      <input
                        placeholder="Email*"
                        className="lead-form-input"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                      <div className="download-brochure-btn-div">
                        {isSubmitting ? (
                          <div class="spinner-border text-danger" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          <button
                            className={`form-enquire-btn ${
                              isSubmitting ? "disabled" : ""
                            }`}
                            type="submit"
                            disabled={isSubmitting}
                          >
                            Enquire Now
                          </button>
                        )}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Success Popup */}
        {showSuccessPopup && (
          <div
            className="modal-overlay"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          >
            <div className="modal-content success-popup">
              <button
                className="close-btn"
                onClick={handleSuccessPopupClose}
                aria-label="Close"
              >
                &times;
              </button>
              <div className="w-100">
                {/* <FaCheckCircle className="success-icon text-center" /> */}
                <img src={Animationthankyou} alt="" />
              </div>
              <h2>Thank you!</h2>
              <p>We've received your submission, and we'll be in touch soon!</p>
            </div>
          </div>
        )}
        <Popup data={popupData} />
      </main>
    </>
  );
};

export default Propertiesbyregion;
